import { Column, ColumnProps } from "primereact/column"
import { DataTable } from "primereact/datatable"
import formatCurrency from "../../../../utils/formatCurrency";
import { Empty } from "./styles";
import empty from '../../../../../assets/img/empty-icon.svg'

interface CustomColumnProps extends ColumnProps {
    isMoney?: boolean
}

interface BillingTableProps {
    itens: any[];
    scrollHeight?: string;
    columns: CustomColumnProps[];
    emptyMessage?: string;
    priceColumn?: string;
}

export const BillingTable: React.FC<BillingTableProps> = ({ itens, columns, scrollHeight = "400px", emptyMessage = "", priceColumn = "transfer_estimate"  }) => {

    const rowClass = (data: any) => {
        return 'customRows'
    }


    const priceBodyTemplate = (rowData: any) => {
        return formatCurrency(rowData[priceColumn]);
    }


    return (
        <>
            {!itens.length ? (
                <Empty>
                    <img src={empty} style={{ height: 60 }} alt="" />
                    <p>{!!emptyMessage ? emptyMessage : "Nada encontrado"}</p>
                </Empty>
            ) : (
                <DataTable removableSort rowClassName={rowClass} scrollable scrollHeight={scrollHeight} value={itens} responsiveLayout="scroll">
                    {columns && columns.map((i) => (
                        <Column key={i.field} field={i.field}
                            header={i.header}
                            sortable={i.sortable}
                            headerStyle={i.headerStyle}
                            bodyStyle={i.bodyStyle}
                            body={i.isMoney ? priceBodyTemplate : i.body}
                        ></Column>
                    ))}
                </DataTable>
            )}

        </>
    )
}